module.exports = __webpack_public_path__ + "img/image 19.574d3b53.png";